import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 60vh;
  justify-content: center;
  text-align: center;

  img.error-icon {
    height: 32px;
    width: 32px;
  }

  p {
    font-size: 16px;
    line-height: 30px;
    margin: 0;

    &.error-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 1.3;
    }
  }

  span {
    font-size: 14px;
    line-height: 24px;
  }

  .error-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`
